import { DragEvent } from "react";
import { Box } from "@mui/material";
import { isNil } from "lodash";
import { OotItemDto } from "../../ootr/hints/OotItemAutocomplete";

interface StaticItemProps{
    name: string,
    image: string,
    onClick?: (v: OotItemDto) => void
}

const StaticItem = (props: StaticItemProps) => {


     const onDrag = (e: DragEvent<HTMLDivElement>) => {
            e.dataTransfer.setData("text/plain", JSON.stringify({ img: props.image, name: props.name } as OotItemDto))
            
    }

    return   <Box display="flex" flexDirection="column" justifyContent="center" onDragOver={(e) => { e.preventDefault(); }} onDragEnter={(e) => { e.preventDefault(); }} >
                <Box display="flex" sx={{ width: "none", justifyContent: "center", alignItems: "center" }}>
                    <img draggable
                        onDragStart={onDrag} src={props.image} alt={props.name} onClick={() => {if(!isNil(props.onClick))props.onClick({ img: props.image, name: props.name} as OotItemDto)}}  height="32px" width="32px" />
                </Box>
    </Box>
}

export default StaticItem